export const SAVE = 'OptimumMedicalBenefitsTugo.SAVE';
export const VALUE_CHANGED = 'OptimumMedicalBenefitsTugo.VALUE_CHANGED';
export const LOAD = 'OptimumMedicalBenefitsTugo.VALUE_LOAD';
export const NEXT = 'OptimumMedicalBenefitsTugo.NEXT';
export const RESET = 'OptimumMedicalBenefitsTugo.RESET';

export const RESET_FORM_STATE = 'OptimumMedicalBenefitsTugo.RESET_FORM_STATE';

export const MEDICAL_EXPENSE_TYPES = {
  DOCTORS_VISIT: "Doctor's Visit",
  DIAGNOSTIC_TESTS: 'Diagnostic Tests',
  PRESCRIPTION_DRUGS: 'Prescription Drugs',
  AMBULANCE_SERVICES: 'Ambulance Services',
  HOSPITALIZATION: 'Hospitalization',
  ESSENTIAL_MEDICAL_APPLIANCES: 'Essential Medical Appliances',
  RETURN_OF_VEHICLE: 'Return of Vehicle',
  PRIVATE_DUTY_NURSING: 'Private Duty Nursing',
  PROFESSIONAL_SERVICES: 'Professional Services',
  DENTAL_SERVICES: 'Dental Services',
  EXPENSES_RELATED_TO_DEATH_REPATRIATION: 'Expenses Related to Death',
  ACCIDENTAL_DEATH_AND_DISMEMBERMENT_BENEFITS: 'Accidental Death and Dismemberment Benefits',
  OTHER_UNRELATED_BENEFIT: 'Other (unrelated to any benefit listed above)',
};

/** Provider types for Professional Services (Standard VTC). Used for form keys and claim-code mapping. */
export const PROFESSIONAL_SERVICES_PROVIDERS = {
  PHYSIOTHERAPIST: 'physiotherapist',
  CHIROPRACTOR: 'chiropractor',
  CHIROPODIST: 'chiropodist',
  OSTEOPATH: 'osteopath',
  PODIATRIST: 'podiatrist',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.OptimumMedicalBenefits/constants.js